import React, { useEffect, useState } from "react";

import { Formik } from "formik";
import { Form } from "formik-antd";
import styled from "styled-components";
import { Space, Button, Card } from "antd";

import { Colors } from "configs";
import PageTemplate from "template/PageTemplate";
import { getReportsCourses } from "services/reports";
import { generateReportXLSX } from "./ReportGenerator";
import { FormDropdown, FormButtons, Row } from "common";
import ResultFilter from "../../../components/ResultFilter/index";
import { Toast } from "../../../utils";

const CustomSpace = styled(Space)`
  width: 100%;
  .ant-space-item {
    width: 100%;
  }
`;

export default function BackofficeCoursesReport() {
  const [loading, setLoading] = useState(false);
  const [listYears, setListYears] = useState([]);
  const [coursesReport, setCoursesReport] = useState([]);

  const handleFilter = async (value) => {
    try {
      setLoading(true);
      if (!value.year) {
        Toast.showWarnMessage("Ano inválido!");
        return;
      };

      const [data1, data2, data3, data4] = await Promise.all([getReportsCourses(value.year, 1), getReportsCourses(value.year, 2), getReportsCourses(value.year, 3), getReportsCourses(value.year, 4)]);

      const data = [...data1.data, ...data2.data, ...data3.data, ...data4.data];
      const newData = data.sort((a, b) => a.created_at - b.created_at);
      setCoursesReport(newData);
    } catch (error) {
      Toast.showErrorMessage("Erro ao buscar relatório!");
    } finally {
      setLoading(false);
    }
  };

  function exportReport() {
    generateReportXLSX(coursesReport);
  }

  const getYears = () => {
    const years = [];
    const date = new Date();
    const currentYear = date.getFullYear();

    for (let index = 2022; index <= currentYear; index++) {
      years.push({
        label: index,
        value: index,
      });
    }

    const sortYears = years.sort((a, b) => b.value - a.value);

    setListYears(sortYears);
  };

  useEffect(() => {
    getYears();
  }, []);

  return (
    <PageTemplate title="Relatório de progresso do aluno" backButton={false}>
      <ResultFilter opened>
        <Formik initialValues={{ year: "" }} onSubmit={(values) => handleFilter(values)}>
          {({ handleSubmit, handleReset, values }) => (
            <Form>
              <CustomSpace direction="horizontal">
                <FormDropdown placeholder="Ano" name="year" value={values.year} list={listYears} />
              </CustomSpace>
              <FormButtons bt2={{ label: "Buscar", onClick: handleSubmit, loading: loading, disabled: loading }} bt1={{ label: "Limpar", onClick: handleReset }} />
            </Form>
          )}
        </Formik>
      </ResultFilter>

      {coursesReport?.length > 0 && (
        <Card>
          <Row
            style={{
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span>Total de items: {coursesReport?.length}</span>
            <Button
              style={{
                backgroundColor: Colors.primary,
                borderColor: Colors.primary,
                color: Colors.white,
              }}
              onClick={exportReport}
            >
              Exportar Relatório
            </Button>
          </Row>
        </Card>
      )}
    </PageTemplate>
  );
}
